module.exports = __webpack_public_path__ + "static/media/angle-left.60f083e8.svg";